
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_vhdn9_103",
  "tools": "awsui_tools_wih1l_vhdn9_114",
  "tools-filtering": "awsui_tools-filtering_wih1l_vhdn9_122",
  "tools-align-right": "awsui_tools-align-right_wih1l_vhdn9_136",
  "tools-pagination": "awsui_tools-pagination_wih1l_vhdn9_140",
  "tools-preferences": "awsui_tools-preferences_wih1l_vhdn9_140",
  "tools-small": "awsui_tools-small_wih1l_vhdn9_146",
  "table": "awsui_table_wih1l_vhdn9_152",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_vhdn9_158",
  "wrapper": "awsui_wrapper_wih1l_vhdn9_162",
  "variant-stacked": "awsui_variant-stacked_wih1l_vhdn9_169",
  "wrapper-content-measure": "awsui_wrapper-content-measure_wih1l_vhdn9_169",
  "variant-container": "awsui_variant-container_wih1l_vhdn9_169",
  "has-footer": "awsui_has-footer_wih1l_vhdn9_172",
  "has-header": "awsui_has-header_wih1l_vhdn9_175",
  "cell-merged": "awsui_cell-merged_wih1l_vhdn9_192",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_vhdn9_204",
  "empty": "awsui_empty_wih1l_vhdn9_222",
  "loading": "awsui_loading_wih1l_vhdn9_226",
  "selection-control": "awsui_selection-control_wih1l_vhdn9_235",
  "selection-control-header": "awsui_selection-control-header_wih1l_vhdn9_242",
  "header-secondary": "awsui_header-secondary_wih1l_vhdn9_248",
  "table-has-header": "awsui_table-has-header_wih1l_vhdn9_266",
  "header-controls": "awsui_header-controls_wih1l_vhdn9_270",
  "variant-full-page": "awsui_variant-full-page_wih1l_vhdn9_273",
  "variant-embedded": "awsui_variant-embedded_wih1l_vhdn9_279",
  "variant-borderless": "awsui_variant-borderless_wih1l_vhdn9_279",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_vhdn9_284",
  "footer": "awsui_footer_wih1l_vhdn9_284",
  "footer-with-pagination": "awsui_footer-with-pagination_wih1l_vhdn9_292",
  "footer-pagination": "awsui_footer-pagination_wih1l_vhdn9_300",
  "thead-active": "awsui_thead-active_wih1l_vhdn9_304",
  "row": "awsui_row_wih1l_vhdn9_305",
  "row-selected": "awsui_row-selected_wih1l_vhdn9_306"
};
  